module.exports = __webpack_public_path__ + "media/images/FWU-Logo-RGB-orange-8b7fb49c985f753719c6024898813262.svg";